import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import Item from "./Item";

export default function ItemList(props) {
  const [acOpen, setAcOpen] = useState(false);

  // console.log("log for totalbill--------", props.header.totalbill);

  if (!props.items || !Array.isArray(props.items)) {
    return null;
  }

  return (
    <>
      <div className="purchase_acr">
        {props.items.map((medicine, index) => {
          return <Item key={index} {...medicine} eventKey={index} />;
        })}
      </div>
      <div className="purchase_total mt-3">
        <Row>
          <Col>
            {" "}
            <h4>Invoice Value</h4>{" "}
          </Col>
          <Col>
            {" "}
            <h4>₹ {props.totalBill ? parseFloat(props.totalBill).toFixed(2) : (props.header && props.header.totalbill ? parseFloat(props.header.totalbill).toFixed(2) : "0.00")}</h4>{" "}
          </Col>
        </Row>
        <div>
          <div
            className="purchase_total_acr_title"
            style={{cursor: 'pointer'}}
            onClick={() => setAcOpen(!acOpen)}
          >
            <Row>
              <Col>
                {" "}
                <p>
                  {" "}
                  <FontAwesomeIcon
                    icon={acOpen ? faChevronUp : faChevronDown}
                  />{" "}
                  Breakup
                </p>
              </Col>
            </Row>
          </div>
          {acOpen && (
            <div className="purchase_total_acr_detail">
              <Row>
                {" "}
                <Col>Gross Amount:</Col>{" "}
                <Col>
                  ₹ {props.header && (props.totalBill || props.header.totalbill)
                    ? (parseFloat(props.totalBill || props.header.totalbill) + parseFloat(props.header.totaldiscountamt || 0)).toFixed(2)
                    : "0.00"}
                </Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>Taxable Amount:</Col>{" "}
                <Col>₹ {props.header && (props.totalBill || props.header.totalbill)
                  ? (parseFloat(props.totalBill || props.header.totalbill) -
                    (parseFloat(props.header.totalcgstamt || 0) +
                      parseFloat(props.header.totalsgstamt || 0) +
                      parseFloat(props.header.totaligstamt || 0) +
                      parseFloat(props.header.totalcessamt || 0))).toFixed(2)
                  : "0.00"}</Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>Discount:</Col>{" "}
                <Col>₹ {props.header && props.header.totaldiscountamt ? parseFloat(props.header.totaldiscountamt).toFixed(2) : "0.00"}</Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>CGST:</Col>{" "}
                <Col>₹ {props.header && props.header.totalcgstamt ? parseFloat(props.header.totalcgstamt).toFixed(2) : "0.00"}</Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>SGST:</Col>{" "}
                <Col>₹ {props.header && props.header.totalsgstamt ? parseFloat(props.header.totalsgstamt).toFixed(2) : "0.00"}</Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>IGST:</Col>{" "}
                <Col>₹ {props.header && props.header.totaligstamt ? parseFloat(props.header.totaligstamt).toFixed(2) : "0.00"}</Col>{" "}
              </Row>
              <Row>
                {" "}
                <Col>Cess Amount:</Col>{" "}
                <Col>₹ {props.header && props.header.totalcessamt ? parseFloat(props.header.totalcessamt).toFixed(2) : "0.00"}</Col>{" "}
              </Row>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
